import { Alert } from '@app/components/icons/alert';
import { Checkmark } from '@app/components/icons/checkmark';
import { Transition } from '@headlessui/react';
import { useTranslation } from '@hopin-team/provider-translation';
import cx from 'classnames';
import React from 'react';
import { resolveValue, Toaster, ToastType } from 'react-hot-toast';

const ToastIcon = ({ type }: { type: ToastType }) => {
  if (type === 'success') return <Checkmark className="h-4 w-4" />;

  if (type === 'error') return <Alert className="h-4 w-4" />;

  return null;
};

export const ToastContainer = () => {
  const { t } = useTranslation();

  return (
    <Toaster>
      {toast => {
        const message = resolveValue(toast.message, toast);

        return (
          <Transition
            appear
            show={toast.visible}
            className={cx(
              'flex transform items-center justify-center rounded p-4 text-white shadow-lg',
              {
                'bg-green-400': toast.type === 'success',
                'bg-red-300': toast.type === 'error',
              },
            )}
            enter="transition-all duration-150"
            enterFrom="opacity-0 scale-50"
            enterTo="opacity-100 scale-100"
            leave="transition-all duration-150"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-75"
            aria-live="polite"
          >
            <ToastIcon type={toast.type} />
            <span className="px-4">
              {typeof message === 'string' ? t(message) : message}
            </span>
          </Transition>
        );
      }}
    </Toaster>
  );
};
